import {useCallback, useMemo, useState} from 'react';

import {userSavedSearchesReplaceV2} from 'src/openapi/admin/apis/UserSavedSearchesReplaceV2Api';
import {useAppDispatch} from 'src/store/hooks';

export const useTemplateSettings = ({userId, defaultValue}: {userId: number, defaultValue?: boolean}) => {
    const [savedSearches, setSavedSearches] = useState<boolean>(defaultValue ?? true);
    const [emailAlerts, setEmailAlerts] = useState<boolean>(defaultValue ?? true);
    const [templates, setTemplates] = useState<boolean>(defaultValue ?? true);

    const [selectedTemplateUserId, setSelectedTemplateUserId] = useState<number | null>(null);
    const [selectedTemplateUserIdInitial, setSelectedTemplateUserIdInitial] = useState<number | null>(null);

    const appDispatch = useAppDispatch();

    const onSave = useCallback(() => {
        const error: string | undefined = undefined;

        if (selectedTemplateUserId) {
            appDispatch(userSavedSearchesReplaceV2({
                userId,
                userSearchesReplaceRequest: {
                    replaceLayouts: templates,
                    replaceSearches: savedSearches,
                    replaceAlerts: emailAlerts,
                    templateUserId: selectedTemplateUserId,
                },
            }));

            setSelectedTemplateUserIdInitial(selectedTemplateUserId);
        }

        return error;
    }, [selectedTemplateUserId, savedSearches, emailAlerts, templates, userId, appDispatch]);

    const updateSelectedTemplateUserId = useCallback((accId: null | number) => {
        if (selectedTemplateUserIdInitial === null) {
            setSelectedTemplateUserIdInitial(accId);
        }
        setSelectedTemplateUserId(accId);
        if (!accId) {
            setSavedSearches(false);
            setEmailAlerts(false);
            setTemplates(false);
        }
    }, [setSelectedTemplateUserIdInitial, selectedTemplateUserIdInitial]);

    const isChanged = useMemo(
        () => selectedTemplateUserId !== selectedTemplateUserIdInitial,
        [selectedTemplateUserId, selectedTemplateUserIdInitial],
    );

    return {
        savedSearches, setSavedSearches,
        emailAlerts, setEmailAlerts,
        templates, setTemplates,

        selectedTemplateUserId,
        setSelectedTemplateUserId: updateSelectedTemplateUserId,

        onSave,
        isChanged,
    };
};
